import ParagraphTypeContainer from './components/paragraph-type-container/paragraph-type-container';

console.info('Starting animation JavaScript stack');

const paragraphTypeContainer = new ParagraphTypeContainer();
paragraphTypeContainer.run();
